import { useFieldArray, useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import DamageBox from "../../components/ContactService/DamageBox";
import { connect } from "react-redux";
import { RootState } from "../../store/root-reducer";
import { useEffect, useMemo } from "react";
import { ChildFlatItem } from "../../types/general";

function DamageDetails({ claimOptions }) {
  const { t } = useTranslation();
  const { control } = useFormContext();
  const { fields, append, remove } = useFieldArray({
    control,
    name: "claimItemDamage",
  });

  useEffect(() => {
    if (fields.length === 0) {
      append({
        damage_category: "",
        specific_damage: "",
        damage_area: "",
        when_did_you_notice_the_damage: "",
        how_did_it_happen: "",
        did_you_take_any_steps_to_remedy: "",
        note: "",
      });
    }
  }, [fields.length, append]);

  const {
    damageTypes,
    specificDamages,
    specificLocations,
    actionsTaken,
    howDidOccur,
  } = claimOptions || {};

  const {
    damageTypesOptions,
    specificDamageOptions,
    specificLocationOptions,
    occuredReasonOptions,
    actionTakenOptions,
  } = useMemo(() => {
    const specificLocationOptions =
      specificLocations?.map((v) => ({
        label: v.name,
        value: v.id,
      })) || [];
    const occuredReasonOptions =
      howDidOccur?.map((v) => ({
        label: v.name,
        value: v.id,
      })) || [];
    const actionTakenOptions =
      actionsTaken?.map((v) => ({
        label: v.name,
        value: v.id,
      })) || [];

    const damageTypesOptions =
      damageTypes?.map((v) => ({
        label: v.name,
        value: v.id,
      })) || [];

    const specificDamageOptions: Record<
      string,
      { label: string; value: string | number }[]
    > = {};
    specificDamages?.forEach((item: ChildFlatItem) => {
      if (!specificDamageOptions[item.parrentId]) {
        specificDamageOptions[item.parrentId] = [];
      }
      specificDamageOptions[item.parrentId].push({
        label: item.name,
        value: item.id,
      });
    });

    return {
      specificLocationOptions,
      occuredReasonOptions,
      actionTakenOptions,
      specificDamageOptions,
      damageTypesOptions,
    };
  }, [
    actionsTaken,
    damageTypes,
    howDidOccur,
    specificDamages,
    specificLocations,
  ]);

  return (
    <div className="space-y-4">
      {fields.map((item, index) => (
        <DamageBox
          key={item.id}
          idx={index}
          item={item}
          onDelete={remove}
          damageTypesOptions={damageTypesOptions}
          specificDamageOptions={specificDamageOptions}
          specificLocationOptions={specificLocationOptions}
          occuredReasonOptions={occuredReasonOptions}
          actionTakenOptions={actionTakenOptions}
        />
      ))}
      <button
        type="button"
        className="w-full border-[#2D6CCA] p-3 text-[#2D6CCA] hover:bg-[#2D6CCA] hover:text-white text-base font-medium border rounded-xl transition-colors duration-200 -mb-6"
        onClick={() =>
          append({
            damage_category: "",
            specific_damage: "",
            damage_area: "",
            when_did_you_notice_the_damage: "",
            how_did_it_happen: "",
            did_you_take_any_steps_to_remedy: "",
            note: "",
          })
        }
      >
        {t("+ Add Damage")}
      </button>
    </div>
  );
}

const mapStateToProps = (state: RootState) => ({
  claimOptions: state.user.claimOptions,
});

export default connect(mapStateToProps)(DamageDetails);
